module.exports = __webpack_public_path__ + "src/assets/img/share/tips/pleasant/25f0bdbb745ab20dc4b2781ac3b6b3b6.png";